// @ts-nocheck
import React, { useState } from 'react';
import { memo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, CardBody } from '@components/card/card';
import useGetLocations from '@hooks/HRSetting/use-get-locations';
import ModalComponent from '@components/Modal/ModalComponent';
import AddLocation from './AddLocation';
import EditLocation from './EditLocation/EditLocation';
import Pagination from '@components/Shared/Pagination/Pagination';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import Breadcrumb from '@components/Shared/Breadcrumb';
import Loading from '@components/Shared/Loader/Loading';

const Location = () => {
  const { HasPermission } = usePermissions();
  const [Id, setId] = useState('');

  const [Show, setShow] = useState(false);
  const { t, i18n } = useTranslation();
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage] = useState(6);

  const Navigate = useNavigate();

  const { Locations, loading, error } = useGetLocations();

  const filteredSearch = Locations?.slice()?.filter(item => {
    const searchLowerCase = search.toLowerCase();
    return item.name?.toLowerCase().includes(searchLowerCase) || item.name2?.toLowerCase().includes(searchLowerCase);
  });

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = filteredSearch?.slice(indexOfFirstData, indexOfLastData);

  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome'
    },
    {
      name: t('Locations'),
      link: null
    }
  ];
  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('Locations')} />
        {HasPermission('AddHrLocation') && (
          <div className='ms-auto'>
            <Link
              to=''
              className='btn btn-theme'
              data-bs-toggle='modal'
              data-bs-target='#modalAddLocation'
              onClick={() => setShow(true)}
            >
              <i className='fa fa-plus-circle fa-fw me-1'></i>
              {t('AddLocation')}
            </Link>
          </div>
        )}
      </div>
      <Card>
        <CardBody>
          <Loading loading={loading} error={error}>
           
               <div className='row mb-4'>
              <div className='col-md-12'>
                <div className='input-group'>
                  <span className='input-group-text fw-bold'>
                    <i className='fa fa-search text-theme me-2'></i>
                    {t('Search')}
                  </span>
                  <input
                    type='text'
                    autoComplete='off'
                    className='form-control  '
                    onChange={e => setSearch(e.target.value)}
                  />
                </div>
              </div>
            </div>

              <div className='mb-5'>
                <div className='row g-4'>
                  {currentData?.map(item => (
                    <div className='col-md-4' key={item.id}>
                      <Card className='h-100 shadow-sm'>
                        <div className='card-body d-flex flex-column'>
                          {/* إضافة أيقونة الموقع هنا */}
                          <div className='d-flex align-items-center mb-2'>
                            <i className='fas fa-map-marker-alt text-theme me-2'></i>
                            <h5 className='card-title mb-0'>{i18n.language === 'ar' ? item.name2 : item.name}</h5>
                          </div>

                          <div className='mb-3 position-relative'>
                            <iframe
                              className='rounded shadow-sm'
                              title={i18n.language === 'ar' ? item.name2 : item.name}
                              src={`https://www.google.com/maps/embed/v1/place?q=${item.latitude},${item.longitude}&key=AIzaSyCG3Kt_jO8o7x67EsdV9RuTJP5IxSEwmeo`}
                              style={{
                                border: 0,
                                width: '100%',
                                height: '180px'
                              }}
                              allowFullScreen
                              loading='lazy'
                            />
                          </div>

                          <div className='mt-auto d-flex justify-content-end'>
                            <button
                              className='btn btn-sm btn-outline-secondary me-2'
                              title='تعديل بيانات الموقع'
                              data-bs-toggle='modal'
                              data-bs-target='#modalEditLocation'
                              onClick={() => setId(item.id)}
                            >
                              <i className='fas fa-edit'></i>
                            </button>
                          </div>
                        </div>
                      </Card>
                    </div>
                  ))}
                </div>

                {filteredSearch?.length > 0 && (
                  <div className='mt-4'>
                    <Pagination
                      filteredData={filteredSearch}
                      dataPerPage={dataPerPage}
                      handlePagination={pageNumber => setCurrentPage(pageNumber)}
                      currentPage={currentPage}
                    />
                  </div>
                )}
              </div>
             
          </Loading>
        </CardBody>
      </Card>

      <ModalComponent title={t('AddLocation')} id='modalAddLocation'>
        {Show && (
          // <LoadScript googleMapsApiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}>
          <AddLocation />
          // </LoadScript>
        )}
      </ModalComponent>
      <ModalComponent title={t('EditLocation')} id='modalEditLocation'>
        {Id && <EditLocation Id={Id} />}
      </ModalComponent>
    </>
  );
};

export default memo(Location);
